import WidgetBase from '../widget.base';
import { each } from '../../lib/util';
import {
    ORDER_DEFAULT,
    ORDER_ASC,
    ORDER_DESC
} from '../../services/product';

import _ from '../../../../node_modules/underscore/underscore';

const filterModel = {
    order: ORDER_DEFAULT,
    sort: null,
};

const SORT_SELECTOR = '[data-sort]';

export default class ProductKit extends WidgetBase {
    static selector = '[data-js-product-kit]';
    $activeSort = null;
    $tableData = [];

    constructor(el) {
        super(el);

        this.sortBar = this.el.querySelector('[data-table-sort-bar]');
        this.dataRows = this.el.querySelectorAll('.usc-pd__table__row');
        this.tableRows = this.el.querySelector('[data-js-rows]');

        this.sortBar.addEventListener('click', this.handleSortBarClick.bind(this));

        this.$tableData = this.getData();

        this.renderTable();
    }

    handleSortBarClick(e) {
        const $target = $(e.target);

        if (!$target.is(SORT_SELECTOR)) {
            return;
        }

        const {
            sort,
            order
        } = this.sortAndOrder($target.data('sort'));

        if (this.$activeSort !== null && this.$activeSort.data('sort') !== sort) {
            this.$activeSort.removeClass('active asc desc');
        }

        $target.removeClass('desc asc');
        $target.addClass('active ' + order);
        this.$activeSort = $target;
    }

    sortAndOrder(targetSort) {
        const currentSort = filterModel.sort;
        const currentOrder = filterModel.order;

        let targetOrder = ORDER_DEFAULT;

        if (targetSort === currentSort) {
            targetOrder = currentOrder === ORDER_ASC ? ORDER_DESC : ORDER_ASC;
        }

        filterModel.sort = targetSort;
        filterModel.order = targetOrder;

        this.renderTable();

        return {
            sort: targetSort,
            order: targetOrder
        };
    }

    renderTable() {

        // Variables.
        let data;

        // Sort data?
        if (filterModel.sort) {
            data = filterModel.order === 'desc' ?
                _.sortBy(this.$tableData, filterModel.sort).reverse() :
                _.sortBy(this.$tableData, filterModel.sort);
        } else {
            data = this.$tableData;
        }

        // Initialize DOM.
        this.resetTable();

        // Render new DOM elements.
        const idLabelText = document.querySelector(
            '.usc-pd__table__header--id').innerText,
            nameLabelText = document.querySelector(
                '.usc-pd__table__header--name').innerText,
            drawingLabelText = document.querySelector(
                '.usc-pd__table__header--drawing').innerText;
        each(data, (row) => {
            let rowDiv = document.createElement('div');
            rowDiv.classList.add('usc-pd__table__row');
            rowDiv.classList.add('usc-pd__table__row--kit-bill-materials');

            let idDiv = document.createElement('div');
            let id = document.createTextNode(row.id);
            let idLabel = document.createElement('label');
            idLabel.classList.add('usc-pd__table__cell-label');
            idLabel.appendChild(document.createTextNode(idLabelText));
            idDiv.classList.add('usc-pd__table__row--id');
            idDiv.classList.add('usc-pd__table__cell');
            idDiv.appendChild(id);

            let nameDiv = document.createElement('div');
            let name = document.createTextNode(row.name);
            let nameLabel = document.createElement('label');
            nameLabel.classList.add('usc-pd__table__cell-label');
            nameLabel.appendChild(document.createTextNode(nameLabelText));
            nameDiv.classList.add('usc-pd__table__row--name');
            nameDiv.classList.add('usc-pd__table__cell');
            nameDiv.appendChild(name);

            let drawingDiv = document.createElement('div');
            let drawingLabel = document.createElement('label');
            drawingLabel.classList.add('usc-pd__table__cell-label');
            drawingLabel.appendChild(document.createTextNode(drawingLabelText));
            drawingDiv.classList.add('usc-pd__table__row--drawing');
            drawingDiv.classList.add('usc-pd__table__cell');
            drawingDiv.innerHTML = row.drawing;

            rowDiv.appendChild(idLabel);
            rowDiv.appendChild(idDiv);
            rowDiv.appendChild(nameLabel);
            rowDiv.appendChild(nameDiv);
            rowDiv.appendChild(drawingLabel);
            rowDiv.appendChild(drawingDiv);

            this.tableRows.appendChild(rowDiv);
        });

    }

    resetTable() {
        this.tableRows.innerHTML = null;
    }

    getData() {
        let data = [];

        each(this.dataRows, (row) => {
            data.push({
                id : row.querySelector('.usc-pd__table__row--id').innerHTML,
                name : row.querySelector('.usc-pd__table__row--name').innerHTML,
                drawing : row.querySelector('.usc-pd__table__row--drawing').innerHTML
            });
        });

        return data;
    }
}
